import { Profile } from 'app/components/Profile';

const ProfilePage = () => {
  return <Profile />;
};

export default ProfilePage;
